import { useEffect } from 'react';

import { cssVar, useElementDimensions } from 'ovpn-ui-toolkit';

/**
 * Billing banner is a separete MFE rendered and managed by Billing team.
 * This hooks is responsible for shifting top page offset if banner is visible.
 */
export function useBillingBannerOffset() {
    const { height: billingBannerOffset = 0 } = useElementDimensions('.billing-banner');

    useEffect(() => {
        cssVar.setNumber('--sidebar-top-offset', billingBannerOffset);
    }, [billingBannerOffset]);
}
